// extracted by mini-css-extract-plugin
export default {"base":"U_3w9","isPageLoader":"ZoGpe","cell":"U2pUD","icon":"lxXLT","inlineIcon":"ZKnkL","inline":"UTxhJ","spin":"cEZg7"};